import { Box } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';

import { COURSE_URL, USERS_URL } from '../../../../constants/urls';
import useRouterQueryId from '../../../../hooks/useRouterQueryId';
import useNoteIdMetadataQuery from '../hooks/queries/useNoteIdMetadataQuery';
import useNoteIdWithUnitsQuery from '../hooks/queries/useNoteIdWithUnitsQuery';
import CourseInformation from './CourseInformation';
import TopLabel from './TopLabel';

export default function NoteDetailHeader() {
  const { t } = useTranslation();
  const courseNoteId = useRouterQueryId();

  const { data: metadata, isLoading: isMetadataLoading } = useNoteIdMetadataQuery(courseNoteId);
  const isWritable = metadata?.isWritable;

  const { data: noteData } = useNoteIdWithUnitsQuery({ id: courseNoteId });
  const course = noteData?.course;
  const writer = noteData?.writer;

  return (
    <>
      <Box css={{ alignSelf: 'flex-start', minHeight: 26 }}>
        <TopLabel isWritable={isWritable} isLoading={isMetadataLoading} />
      </Box>
      <Box>
        <CourseInformation
          course={
            course && {
              ...course,
              href: isWritable
                ? COURSE_URL.COURSE_DASHBOARD(course.slug)
                : COURSE_URL.COURSE_DETAIL(course.slug),
            }
          }
          writer={
            writer && {
              ...writer,
              label: t('노트 작성자'),
              href: USERS_URL.HOME({ userId: String(writer.id) }),
            }
          }
        />
      </Box>
    </>
  );
}
